module.exports = __webpack_public_path__ + "img/litera.30d20b80.png";